import React, { useEffect, useState } from "react";
import { Card, Tabs, Typography, Button, Row, Col, Progress, Spin } from "antd";
import { UsergroupAddOutlined,ExportOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useInjectReducer, useInjectSaga } from "redux-injectors";
import { reducer, sliceKey, actions } from "./slice";
import { samplingTrackingSummarySaga } from "./saga";
import * as selectors from "./selectors";

const { TabPane } = Tabs;
const { Text } = Typography;

const SamplingTrackingSummary = ({
  filters = {},
  onDetailedClick = () => {},
}) => {
  useInjectReducer({ key: sliceKey, reducer });
  useInjectSaga({ key: sliceKey, saga: samplingTrackingSummarySaga });

  const dispatch = useDispatch();
  const [tab, setTab] = useState("top");

  const loading = useSelector(selectors.selectLoading);
  const data = useSelector(selectors.selectSummaryData);

  const filterString = JSON.stringify(filters);

  useEffect(() => {
    dispatch(actions.fetchSummary({ view: tab, filtersString: filterString }));
  }, [tab, filterString, dispatch]);

  return (
    <Card
      title={
        <span style={{ color: "#fff" }}>
          <UsergroupAddOutlined style={{ marginRight: 8 }} />
          Sampling Tracking
        </span>
      }
      extra={
        <Button onClick={onDetailedClick} icon={<ExportOutlined />}>
          Detailed View
        </Button>
      }
      headStyle={{ backgroundColor: "#0D9488" }}
      style={{ marginTop: 24 }}
    >
      <Tabs activeKey={tab} onChange={setTab}>
        {["top", "bottom"].map((type) => (
          <TabPane
            tab={`${type[0].toUpperCase() + type.slice(1)} 10`}
            key={type}
          >
            {loading ? (
              <Spin />
            ) : (
              Array.isArray(data) &&
              data.map((item, idx) => (
                <Card key={idx} style={{ marginBottom: 8 }}>
                  <Row justify="space-between" align="middle">
                    <Col>
                      <Text strong>
                        {idx + 1}. {item.samplerName}
                      </Text>
                      <div>
                        {item.state} • {item.district}
                      </div>
                      <div>
                        {item.samplingCompleted} / {item.totalOrders} orders
                        completed
                      </div>
                    </Col>
                    <Col>
                      <Progress
                        percent={parseFloat(item.samplingCompletionScore)}
                        strokeColor="#0D1321"
                        showInfo={false}
                        style={{ width: 120 }}
                      />
                      <div style={{ textAlign: "right", marginTop: 4 }}>
                        {item.samplingCompletionScore}
                      </div>
                    </Col>
                  </Row>
                </Card>
              ))
            )}
          </TabPane>
        ))}
      </Tabs>
    </Card>
  );
};

export default SamplingTrackingSummary;
